export const isObject = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null;

export const hasProperty = <T extends string, U = unknown>(
  obj: unknown,
  property: T
): obj is Record<T, U> => isObject(obj) && property in obj;
